import {Component, Injectable} from '@angular/core';
import {NgbDateStruct, NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';

/**
 * Example of a String Time adapter
 */
@Injectable()
export class NgbDateConverter extends NgbDateAdapter<string> {
    fromModel(value: string): NgbDateStruct {
        if (!value) {
          return null;
        }
        const split = value.split('-',3);
        return {
          day: parseInt(split[0], 10),
          month: parseInt(split[1], 10),
          year: parseInt(split[2], 10)
        };
      }
    
      toModel(date: NgbDateStruct): string {
        if (!date) {
          return null;
        }
        return `${this.pad(date.year)}-${this.pad(date.month)}-${this.pad(date.day)}`;
      }
    
      public pad(i: number): string {
        return i < 10 ? `0${i}` : `${i}`;
      }
}



// WEBPACK FOOTER //
// ./src/app/bi/common/service/ngbDateConverter.utils.ts